import { Inject, Injectable } from '@angular/core';
import { NotificationService } from '../notification/NotificationService';
import { ProxyService } from '../proxy/ProxyService';
import { WINDOW } from '../window/WindowService';
import { IAuthenticationService } from './IAuthenticationService';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService implements IAuthenticationService {
    public static $name = 'authenticationService';

    constructor(
        @Inject(WINDOW) private window: Window,
        private notificationService: NotificationService,
        private proxyService: ProxyService
    ) {
    }

    public logout() {
        this.notificationService.disconnect();

        this.proxyService.request({
            endPoint: 'auth',
            route: 'logout'
        }).asNoContent().then(() => {
            this.window.location.replace('Account/Login');
        });
    }
}
